module.exports = __webpack_public_path__ + "static/img/1.88e12929.png";